import React from "react"
import "../CSS/previous_edition.css"
import NavBar from "../Components/NavBar"
import {CINS_2023_FRONTCOVER, CINS_2023_LINK, SPRINGER_LOGO} from "../Constants"


let Previous_Edition_2023 = () => {
    
    return (
        <>  

            <NavBar></NavBar>
            <section className = "previous-edition-heading-section">
                <h1 className = "roboto-condensed-700">Computational Intelligence and Network Systems</h1>
                <h2 className = "roboto-condensed-300">First International Conference, CINS 2023, Dubai, United Arab Emirates, October 18–20, 2023, Proceedings</h2>

                <img src = {CINS_2023_FRONTCOVER}  ></img>
            </section>

            <section className = "publisher-section">
                <h2 className = "roboto-condensed-700">Publisher</h2>


                <img src = {SPRINGER_LOGO}></img>
            </section>

            <a className = "pdf-item" href = {CINS_2023_LINK} style = {{textAlign : "center", color : "black", textDecoration : "none"}}><h3 className = "roboto-condensed-700">Click Here To View Conference Proceedings</h3></a>
        </>
    )
} 

export default Previous_Edition_2023